<template>
    <div>
        <div class="main-cnt ex-has-btm">
            <div class="block-cnt">
                <div class="box-full-w">
                    <div class="content-wallet">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs" v-if="groupType == constants.GroupVoucherType.cash_detail">
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    :class="{'active': screenType == constants.CashScreenType}"
                                    @click="switchScreen(cashId, currencyId, constants.CashScreenType)"
                                >
                                    <i class="icon-wallet mr-2"></i>
                                    {{$t('cash.list_carry')}}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    :class="{'active': screenType == constants.LocalIncomeScreenType}"
                                    @click="switchScreen(cashId, currencyId, constants.LocalIncomeScreenType)"
                                >
                                    <i class="icon-file mr-2"></i>
                                    {{$t('cash.local_income')}}
                                </a>
                            </li>
                            <li v-if="tourInfo.tour_type==foreignType" class="nav-item">
                                <a
                                    class="nav-link"
                                    :class="{'active': screenType == constants.ExchangeScreenType}"
                                    @click="switchScreen(cashId, currencyId, constants.ExchangeScreenType)"
                                >
                                    <i class="icon-yen mr-2"></i>
                                    {{$t('cash.exchange')}}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <tour-info v-model="selectedBizPrePaidCard" :showUseBizPrePaidCard="showUseBizPrePaidCard"></tour-info>

                    <cash-summary
                        v-if="cashDetails.cash_currency && screenType == constants.CashScreenType"
                        :cashDetails="cashDetails"
                        :onChangeCashDetails="onChangeCashDetails"
                        :slickOptions="slickOptions"
                        :useBizPrePaidCard="useBizPrePaidCard"
                        ></cash-summary>
                    <income-summary ref="income_summary"
                        v-else-if="cashDetails.cash_currency && isShowIncomeSummary && screenType == constants.LocalIncomeScreenType"
                        :summarys="summarys" :tourInfo="tourInfo" :slickOptions="summarySlickOptions"></income-summary>
                    <exchange-summary ref="exchange_summary"
                        v-else-if="cashDetails.cash_currency && isShowExchangeSummary && screenType == constants.ExchangeScreenType"
                        :summarys="summarys" :slickOptions="summarySlickOptions"></exchange-summary>

                    <div class="error-message-voucher" v-if="errorMessage">
                        <div class="d-flex">
                            <i class="icon-warning mr-2"></i>
                            <div class="errror-txt">
                                <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="heading-breadcrumb">{{ getBreadCrumb() }}</div>

                    <div v-show="listVoucher">
                        <div v-for="(voucherList, groupMonth, index) in listVoucher" :key="index" class="table-cnt">
                            <div class="table-heading">{{ dateUtils.formatDateYYYYMM(groupMonth) }}</div>
                            <ul class="lst-static">
                                <li v-for="voucher in voucherList" :key="voucher.id"
                                    :class="{'ex-highlight-row': activeVoucher == voucher.id}"
                                    @click="voucherDetails(voucher.id)">
                                    <voucher-row
                                        :voucher="voucher"
                                        :screenType="screenType"
                                        :isExchange="screenType == constants.ExchangeScreenType"
                                    >
                                    </voucher-row>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="btns-btm" v-if="groupType != constants.GroupVoucherType.cash_detail">
            <div class="d-flex justify-content-between align-items-center">
                <div class="row no-gutters w-100">
                    <div class="col-12 pl-1 pr-1">
                        <button
                            class="btn btn-pink-44 w-100 ex-orange-light mb-0"
                            data-toggle="modal"
                            @click="addVoucherCamera"
                        >
                            <i class="icon-camera mr-2"></i>
                            {{ $t('voucher.button.add_details') }}
                        </button>
                        <input
                            type="file"
                            ref="inputUpload"
                            name
                            class="d-none"
                            accept="image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                            application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel.sheet.macroEnabled.12"
                            multiple
                            @change="preprocessUpload"
                            style="display: none"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="btns-btm" v-if="screenType == constants.ExchangeScreenType">
            <div class="d-flex justify-content-between align-items-center">
                <div class="row no-gutters w-100">
                    <div class="col-6 pl-1 pr-1">
                        <button
                            class="btn btn-pink-44 w-100 ex-orange-light mb-0"
                            data-toggle="modal"
                            @click="addVoucherCamera"
                        >
                            <i class="icon-camera mr-2"></i>
                            {{$t('voucher.button.add_details')}}
                        </button>
                        <input
                            type="file"
                            ref="inputUpload"
                            name
                            class="d-none"
                            accept="image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                            application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel.sheet.macroEnabled.12"
                            multiple
                            @change="preprocessUpload"
                            style="display: none"
                        />
                    </div>
                    <div class="col-6 pr-1 pl-1">
                        <button class="btn btn-pink-44 w-100 ex-orange" @click="addVoucherManual">
                            <i class="icon-pen mr-2"></i>
                            {{$t('voucher.button.manual_input')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="btns-btm"
            v-if="screenType == constants.CashScreenType || screenType == constants.LocalIncomeScreenType"
        >
            <div class="d-flex justify-content-between align-items-center">
                <div class="row no-gutters w-100">
                    <div class="col-4 pl-1 pr-1">
                        <button
                            class="btn btn-pink-44 w-100 ex-orange-light mb-0"
                            data-toggle="modal"
                            @click="addVoucherCamera"
                        >
                            <i class="icon-camera mr-2"></i>
                            {{$t('voucher.button.add_details')}}
                        </button>
                        <input
                            type="file"
                            ref="inputUpload"
                            name
                            class="d-none"
                            accept="image/jpeg, image/png, image/jpg, image/tif, image/tiff, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                            application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel.sheet.macroEnabled.12"
                            multiple
                            @change="preprocessUpload"
                            style="display: none"
                        />
                    </div>
                    <div class="col-4 pr-1 pl-1">
                        <button class="btn btn-pink-44 w-100 ex-orange" @click="addVoucherManual">
                            <i class="icon-pen mr-2"></i>
                            {{$t('voucher.button.manual_input')}}
                        </button>
                    </div>
                    <div class="col-4 pl-1 pr-1">
                        <button
                            class="btn btn-pink-44 w-100 ex-border"
                            @click="onClickOfficialRegisterBtn"
                        >
                            <i class="icon-upload mr-2"></i>
                            {{$t(utils.isCooperator() ? 'voucher.button.preview' : 'voucher.button.official_registration')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <SelectVoucherTypeModal
            :setVoucherType="setVoucherType"
            :screenType="screenType"
            :groupType="groupType"
            :selectFiles="selectFiles"
            :tourInfo="tourInfo"
            :useBizPrePaidCard="useBizPrePaidCard"
            ref="selectVoucherModal"
        ></SelectVoucherTypeModal>

        <SpCameraPreProcessingVoucher
            v-if="showPreprocessingUpload"
            :files.sync="files"
            :voucherType="voucherType"
            :filePath="filePath"
            @finish="finishUpload"
            @close="closePreprocessingUpload"
            @enableButton="$emit('enableButton', $event)"
            @update:actionHandler="$emit('update:actionHandler', $event)"
            @update:backHandler="$emit('update:backHandler', $event)"
            @update-filePath="changeFilePath"
        ></SpCameraPreProcessingVoucher>

        <!-- The Modal Confirm to export excel -->
        <confirm-register-modal
            :summarys="summarys"
            :summarySlickOptions="summarySlickOptions"
            :tourInfo="utils.isCooperator() ? tourInfo : editTourInfo"
            @downloadExcel="downloadExcel"
            @exportExcel="exportExcel"
            @backEditTourInfo="backEditTourInfo"
            @onClickCancel="onClickCancel"
            ref="confirmRegister"
        >
        </confirm-register-modal>

        <edit-tour-info-modal
            @confirmRegister="nextOfficialRegistration"
            ref="editTour"
        >
        </edit-tour-info-modal>

        <!-- The Modal export excel success-->
        <b-modal
            id="successRegister"
            modal-class="modal fade modal-upload"
            dialog-class="modal-dialog"
            hide-header hide-footer
            @hidden="exportExcelSuccess"
        >
            <button type="button" class="close" @click="$bvModal.hide('successRegister')">&times;</button>

            <div class="center-modal">
                <div class="center-ttl font300 d-flex justify-content-center">
                    <i class="icon-copy-orange mr-2"></i>
                    <span class="font500 text-pink">{{ msgExportExcel }}</span>
                </div>

                <div class="mt-4 text-center">
                    <i :class="isExportExcelSuccess ? 'icon-checked-circle' : 'icon-failed-circle'"></i>
                </div>
            </div>
        </b-modal>
        <b-modal class="modal fade modal-upload" id="errorDownloadExcel" hide-header hide-footer>
            <button type="button" class="close" @click="$bvModal.hide('errorDownloadExcel')">&times;</button>

            <div class="center-modal">
                <div class="center-ttl font300 d-flex justify-content-center">
                    <i class="icon-error-preview mr-2"></i>
                    <span class="font500 text-pink">{{ msgErrorDownloadExcel }}</span>
                </div>
            </div>
        </b-modal>
        <!-- Pdf viewer -->
        <pdf :voucher="voucher" v-if="showPdfViewer" :closePdf="closePdf"></pdf>

        <!-- The Modal confirm no payment register-->
        <b-modal class="modal fade" id="confirmNoPaymentRegister" v-model="isConfirmNoPaymentRegisterModalActive" centered hide-header hide-footer no-close-on-backdrop no-close-on-esc>
            <button v-if="!isCancelConfirm" type="button" class="close" @click="$bvModal.hide('confirmNoPaymentRegister')">&times;</button>
            <button v-else type="button" class="close" @click="showConfirmRegsiter(); $bvModal.hide('confirmNoPaymentRegister')">&times;</button>
            <div class="center-modal">
                <div class="center-ttl font300 d-flex justify-content-center" v-if="!isCancelConfirm">
                    {{ $t('voucher.modal-confirmNoPaymentRegister.message_no_data') }} <br/>
                    {{ utils.isCooperator() ? $t('voucher.modal-confirmNoPaymentRegister.message_preview') : $t('voucher.modal-confirmNoPaymentRegister.message_confirm') }}
                </div>
                <div class="center-ttl" style="text-align:center" v-else>
                    <div class=" font500">
                        本登録作業を中止しますか？
                    </div>
                    <p style="font-size: 12px; font-weight:300">
                        団体情報修正内容は破棄されますのでご注意ください。<br>
                        確認画面に戻る場合は、この画面を×で閉じてください
                    </p>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="pr-2 w-165" v-if="!isCancelConfirm">
                        <button class="btn btn-pink-53 w-100" type="button" @click="onClickNoPaymentRegister">
                            {{ $t('button.ok') }}
                        </button>
                    </div>
                    <div class="pr-2 w-165" v-else>
                        <button class="btn btn-pink-53 w-100" type="button" @click="onClickNoPaymentRegister">
                            {{ $t('button.cancelRegister') }}
                        </button>
                    </div>
                    <div class="pl-2 w-165" v-if="!isCancelConfirm">
                        <button class="btn btn-gray-53 w-100" type="button" @click="$bvModal.hide('confirmNoPaymentRegister')">
                            {{ $t('button.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
/* global $ */
import _ from 'lodash';
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';
import fileReader from "@/helpers/fileReader";
import { Constants } from "@/helpers/constants";

import { AuthService } from "@/services/common/auth.service";
import StorageService from "@/services/common/storage.service";
import VoucherService from "@/services/module/voucher.service";
import CashService from "@/services/module/cash.service";

import TourInfo from "@/views/components/sp/Tour/Info";
import DeleteVoucher from "@/views/components/pc/Voucher/DeleteVoucher";
import SelectVoucherTypeModal from "@/views/components/pc/Voucher/SelectVoucherTypeModal";
import PreviewFileUpload from "@/views/components/pc/Voucher/PreviewFileUpload";
import UploadFileModal from "@/views/components/pc/Voucher/UploadFileModal";
import ShowImg from "@/views/components/pc/Voucher/ShowImg";
import SpCameraPreProcessingVoucher from "@/views/components/sp/Voucher/CameraPreProcessing";
import Pdf from "@/views/components/sp/Voucher/PdfViewer";
import VoucherManagementService from "@/services/module/voucher.service";
import ConfirmRegisterModal from "@/views/components/sp/Voucher/ConfirmRegisterModal";
import EditTourInfoModal from "@/views/components/sp/Voucher/EditTourInfoModal";
import VoucherRow from "@/views/components/common/VoucherRow";
import CashSummary from "@/views/components/common/Summary/CashSummary";
import IncomeSummary from "@/views/components/common/Summary/IncomeSummary";
import ExchangeSummary from "@/views/components/common/Summary/ExchangeSummary";
import imageCompression from 'browser-image-compression';

export default {
    components: {
        Slick,
        TourInfo,
        DeleteVoucher,
        SelectVoucherTypeModal,
        PreviewFileUpload,
        UploadFileModal,
        ShowImg: ShowImg,
        SpCameraPreProcessingVoucher,
        pdf: Pdf,
        ConfirmRegisterModal,
        EditTourInfoModal,
        VoucherRow,
        CashSummary,
        IncomeSummary,
        ExchangeSummary
    },
    name: "SpVoucherList",
    data () {
        return {
            slickOptions: {
                dots: false,
                arrows: true,
                mobileFirst: true,
                infinite: false,
                slidesToShow: 1,
                centerMode: true,
                initialSlide: 0,
                variableWidth: true,
            },
            utils: Utils,
            dateUtils: DateUtils,
            constants: Constants,
            cashId: "",
            cash_id: "",
            currencyId: "",
            cashDetails: [],
            listVoucher: [],
            voucherId: "",
            cashDmosId: "",
            screenType: "",
            activeVoucher: "",
            errorMessage: "",
            voucher: {},
            groupType: "",
            voucherType: "",
            voucherParams: {
                voucherTypeId: "",
                cashInOutType: "",
                cashId: "",
            },
            ocrData: {},
            num: 0,
            files: [],
            showPreprocessingUpload: false,
            msgExportExcel: "",
            isExportExcelSuccess: false,
            msgErrorDownloadExcel: "",
            foreignType: Constants.TourType.international.id,
            tourInfo: {},
            showPdfViewer: false,
            summarys: [],
            summarySlickOptions:{
                dots: false,
                arrows: true,
                mobileFirst: true,
                infinite: false,
                slidesToShow: 1,
                centerMode: true,
                initialSlide: 0,
                variableWidth: true,
            },
            isShowIncomeSummary: false,
            isShowExchangeSummary: false,
            filePath: "",
            signature: false,
            isConfirmNoPaymentRegisterModalActive: false,
            editTourInfo: {},
            isCancelConfirm: false,
            showTour : false,
            storageService: StorageService,
            selectedBizPrePaidCard: Constants.bizPrePaidCard[1],
        };
    },
    created () {
        this.$emit("enableButton", '<i class="icon-logout"></i>');
        this.$emit("update:actionHandler", () => {
            AuthService.logout();
        });
    },
    beforeMount () {
        this.tourInfo = JSON.parse(StorageService.getTour());
        if (this.$route.query.groupType) {
            this.groupType = this.$route.query.groupType;
            this.listVouchers();
            this.getSummaryData();
        } else {
            if (this.$route.query.screenType) {
                this.screenType = this.$route.query.screenType; //queryから取得する時だけ型がstring
            } else {
                this.screenType = Constants.CashScreenType;
            }
            this.groupType = Constants.GroupVoucherType.cash_detail;
            this.cashDmosId = StorageService.getCashId();
            const storageCCid = StorageService.getCurrencyId();
            if (!Utils.isEmptyStr(storageCCid)) {
                this.currencyId = storageCCid;
            };

            this.getCashDetails("", "", "");
        }
    },
    computed: {
      useBizPrePaidCard: function () {
        return this.showUseBizPrePaidCard && this.selectedBizPrePaidCard.id === 1;
      },
      showUseBizPrePaidCard: function () {
        return this.screenType == Constants.CashScreenType;
      }
    },
    methods: {
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },
        getCashDetails (cashId = "", currencyId = "", screenType = "") {
            this.cashDetails = [];
            this.cashDmosId = StorageService.getCashId();
            if (!this.cashDmosId) {
                let tourInfo = JSON.parse(StorageService.getTour());
                if (tourInfo && tourInfo.tour_number) {
                    this.$router.push(
                        "/tour/after-input?search=" + tourInfo.tour_number
                    );
                } else {
                    this.$router.push(
                        "/tour/input"
                    );
                }
            }
            CashService.getCashDetail(
                this.cashDmosId,
                this.tourInfo.tour_number
            ).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        this.errorMessage = this.$root.$t(
                            "error.error_code_" + errorCode
                        );
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        StorageService.saveCashIdServer(response.data.id);
                        this.cashDetails = response.data;
                        if (Utils.isEmptyStr(this.currencyId)) {
                            this.currencyId = Constants.JPY.id;
                        };
                        if (!Utils.isEmptyStr(currencyId)) {
                            this.currencyId = currencyId;
                        };

                        let currencies = this.cashDetails.cash_currency;
                        for (var i = 0; i < currencies.length; i++) {
                            if (currencies[i].currency_id == this.currencyId) {
                                this.slickOptions.initialSlide = i;
                            }
                        }
                        let obj = _.filter(currencies, {
                            currency_id: parseInt(this.currencyId),
                        });
                        if (Utils.isEmptyStr(obj)) {
                            if (!Utils.isEmptyStr(currencies[0])) {
                                this.currencyId = currencies[0].currency_id;
                            }
                        }
                        this.cashId = response.data.id;
                        this.listVouchers(cashId, currencyId, screenType);
                        this.getSummaryData();
                    } else {
                        this.cashDetails = [];
                        var options = {
                                className: 'toast-position'
                            }
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, options);
                    }
                }
            });
        },
        getSummaryData () {
            this.summarys = [];
            if (Utils.isEmptyStr(this.screenType)) {
                return this.summarys;
            }
            return CashService.getSummary(this.cashId)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.errorMessage = this.$root.$t(
                                "error.error_code_" + errorCode
                            );
                        }
                    } else {
                        this.summarys = response.data;
                        this.isIncomesAndExchanges();
                        this.reInit();
                    }
                })
        },
        isIncomesAndExchanges () {
            this.isShowIncomeSummary = false;
            this.isShowExchangeSummary = false;
            for (let i = 0; i < this.summarys.length; i++) {
                const row = JSON.parse(JSON.stringify(this.summarys[i]));
                if (Object.keys(row.local_incomes).length) {
                    this.isShowIncomeSummary = true;
                }

                if (Object.keys(row.exchanges).length) {
                    this.isShowExchangeSummary = true;
                }
            }
        },
        reInit () {
            if(this.$refs.confirmRegister){
                this.$refs.confirmRegister.$refs.slick_preChecks.destroy();
                this.$nextTick(() => {
                    this.$refs.confirmRegister.$refs.slick_preChecks.create();
                });
            }
            if (this.screenType == Constants.LocalIncomeScreenType && this.isShowIncomeSummary) {
                const incomeSummary = this.$refs.income_summary
                if(typeof incomeSummary != 'undefined'){
                    const slickIncom = this.$refs.income_summary.$refs.slick_incomes;
                    if (typeof slickIncom != 'undefined') {
                        slickIncom.destroy();
                        this.$nextTick(() => {
                            slickIncom.create();
                        });
                    }
                }
            } else if (this.screenType == Constants.ExchangeScreenType && this.isShowExchangeSummary) {
                const exchangeSummary = this.$refs.exchange_summary
                if(typeof exchangeSummary != 'undefined'){
                    const slickExchange = this.$refs.exchange_summary.$refs.slick_exchanges;
                    if (typeof slickExchange != 'undefined') {
                        slickExchange.destroy();
                        this.$nextTick(() => {
                            slickExchange.create();
                        });
                    }
                }
            }
        },
        onChangeCashDetails (event, slick, currentSlide) {
            if (currentSlide != this.slickOptions.initialSlide) {
                let currentCurrency = this.cashDetails.cash_currency[currentSlide];
                this.slickOptions.initialSlide = currentSlide;
                // get new data cash currency
                this.getCashCurrency(currentCurrency.id);

                // get new data list voucher
                this.listVouchers(
                    this.cashDetails.id,
                    currentCurrency.currency_id
                );
                this.currencyId = currentCurrency.currency_id;
            }
        },
        listVouchers (cashId = "", currencyId = "", screenType = "") {
            this.reset();
            if (cashId) {
                this.cashId = cashId;
            }
            if (currencyId) {
                this.currencyId = currencyId;
            }
            if (screenType) {
                this.screenType = screenType;
            }
            VoucherService.list(
                this.cashId,
                this.currencyId,
                this.screenType,
                this.groupType,
            )
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.errorMessage = this.$root.$t(
                                "error.error_code_" + errorCode
                            );
                        }
                    } else {
                        if (!Utils.isEmptyObj(response.data)) {
                            this.listVoucher = response.data;
                        } else {
                            this.listVoucher = [];
                            var options = {
                                className: 'toast-position'
                            }
                            let msg = this.$root.$t("general.no_data");
                            this.$toasted.success(msg, options);
                        }
                    }
                })
                .catch(error => {
                    this.errorMessage = this.$root.$t("error.error_unknown");
                });
        },
        getCashCurrency (cashCurrencyId = "") {
            CashService.getCashCurrency(
                cashCurrencyId
            ).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        this.errorMessage = this.$root.$t(
                            "error.error_code_" + errorCode
                        );
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        for (var m = 0; m < this.cashDetails.cash_currency.length; m++) {
                            if (this.cashDetails.cash_currency[m].id == cashCurrencyId) {
                                this.cashDetails.cash_currency[m] = response.data;
                            }
                        }
                    }
                }
            });
        },
        switchScreen (cashId = "", currencyId = "", screenType = "") {
          this.selectedBizPrePaidCard = Constants.bizPrePaidCard[1];
            this.getCashDetails(cashId, currencyId, screenType);
            this.$router.replace({
                path: "/voucher/list",
                query: { screenType: screenType },
            });
        },
        voucherDetails (voucherId) {
            this.activeVoucher = voucherId;
            this.$router.push({
                path: "/voucher/detail",
                query: { voucherId: voucherId, screenType: this.screenType },
            });
        },
        addVoucherManual () {
            this.reset();
            if (this.screenType == Constants.CashScreenType) {
                this.voucherType = Constants.VoucherType.no_voucher.id;
                this.goToAddVoucher();
            }
            if (this.screenType == Constants.LocalIncomeScreenType) {
                this.voucherType =
                    Constants.VoucherType.local_placement_income_other_no_voucher.id;
                this.goToAddVoucher();
            }
            if (this.screenType == Constants.ExchangeScreenType) {
                this.voucherType =
                    Constants.VoucherType.currency_exchange_receipt_cash.id;
                this.goToAddVoucher();
            }
        },
        addVoucherCamera () {
            this.reset();
            if (this.screenType == Constants.CashScreenType) {
                $("#modalSelectVoucherType").modal("show");
                this.$refs.selectVoucherModal.selectType(Constants.VoucherType.receipt_carry_cash.id);
            } else if (this.screenType == Constants.LocalIncomeScreenType) {
                $("#modalSelectVoucherType").modal("show");
                this.$refs.selectVoucherModal.selectType(Constants.VoucherType.receipt_local_placement_income.id);
            } else if (this.screenType == Constants.ExchangeScreenType) {
                this.voucherType =
                    Constants.VoucherType.currency_exchange_receipt_cash.id;
                this.selectFiles();
            } else {
                if (this.groupType == Constants.GroupVoucherType.other) {
                    this.voucherType =
                        Constants.VoucherType.certificate_Registration_other.id;
                    this.selectFiles();
                } else {
                    $("#modalSelectVoucherType").modal("show");
                    this.files = [];
                }
            }
        },
        goToAddVoucher () {
            this.$router.push({
                path: "/voucher/add",
                query: { screenType: this.screenType },
            });
            this.voucherParams = {};
            this.voucherParams.voucherTypeId = this.voucherType;
            this.voucherParams.cashInOutType = this.screenType;
            this.voucherParams.cashId = this.cashId;
            if(this.screenType == Constants.CashScreenType) {
              this.voucherParams.currencyId = this.currencyId;
            }
            let filePath = "";
            if (this.ocrData.path) {
                filePath = this.ocrData.path;
            }
            this.voucherParams.filePath = filePath;
            this.voucherParams.signature = this.signature;
            this.voucherParams.modeAdd = this.modeAdd;
            if (!Utils.isEmptyObj(this.ocrData.ocr) && !Utils.isEmptyObj(this.ocrData.ocr.mapping)) {
                let data = this.ocrData.ocr.mapping.template_mapping;
                if (data.transaction_date && data.transaction_date[0]) {
                    this.voucherParams.transactionDate = new Date(
                        data.transaction_date[0]
                    );
                }
                if (data.use && data.use[0]) {
                    this.voucherParams.use = data.use[0];
                }
                if (data.account_name && data.account_name[0]) {
                    this.voucherParams.accountName = data.account_name[0];
                }
                if (data.personal && data.personal[0]) {
                    this.voucherParams.personal = data.personal[0];
                }
                if (data.unit_price && data.unit_price[0]) {
                    this.voucherParams.unitPrice = data.unit_price[0];
                }
                if (data.amount && data.amount[0]) {
                    if (this.screenType == Constants.LocalIncomeScreenType) {
                        let tourInfo = JSON.parse(StorageService.getTour());
                        if (tourInfo.tour_type == Constants.TourType.domestic.id) {
                            this.voucherParams.localPayment = data.amount[0];
                        } else {
                            this.voucherParams.localPaymentUnitPrice = data.amount[0];
                            this.voucherParams.localPaymentPersonal = 1;
                        }
                    } else {
                        this.voucherParams.totalAmount = data.amount[0];
                    }
                }
            }
            StorageService.saveVoucher(JSON.stringify(this.voucherParams));
        },
        selectFiles () {
            // $("#uploadFileModal").modal("show");
            this.$refs.inputUpload.click();
        },
        async preprocessUpload (e) {
            if (e.target.files.length > Constants.Upload.maxFile) {
                alert(this.$t('voucher.upload.max_file'));
                const el = document.body;
                el.classList.remove("over-hidden");
                e.target.value = "";
                return;
            }

            let isPdf = false;
            const files = [];
            const typePdf = "application/pdf";
            const typeImage = ["image/jpeg", "image/png", "image/jpg"];
            const options = {
                maxWidthOrHeight: 2480,
            };

            for (let i = 0; i < e.target.files.length; i++) {
                const file = e.target.files[i];
                const type = file.type;
                if (type == typePdf) {
                    isPdf = true;
                    files.push(file);
                } else if (typeImage.includes(type)) {
                    const compressedFile = await imageCompression(file, options);
                    console.log(`変換前情報 サイズ:[${file.size}]`);
                    console.log(`変換後情報 サイズ:[${compressedFile.size}]`);
                    files.push(compressedFile);
                } else {
                    files.push(file);
                };
            };

            this.files = files;

            if (isPdf) {
                const formD = await this.getFormData();
                const res = await VoucherManagementService.checkPwdPdf(formD);
                if (res.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (res.status != 200) {
                    let errorCode = Utils.getErrorCode(res);
                    let msg = this.$root.$t("fail.add_fail");
                    if (errorCode) {
                        msg = this.$root.$t("error.error_code_" + errorCode);
                    }
                    this.$toasted.error(msg, {});
                } else {
                    let msg = this.$root.$t("success.add_success");
                    this.$toasted.success(msg, {});
                    this.showPreprocessingUpload = true;
                };
            } else {
                let msg = this.$root.$t("success.add_success");
                this.$toasted.success(msg, {});
                this.showPreprocessingUpload = true;
            };
            const el = document.body;
            el.classList.add("over-hidden");
            // Reset input file
            e.target.value = "";
        },
        finishUpload (responseData) {
            const el = document.body;
            el.classList.remove("over-hidden");
            this.ocrData = responseData;
            this.signature = this.ocrData.signature;
            this.goToAddVoucher();
        },
        changeFilePath (filePath) {
            this.filePath = filePath;
        },
        closePreprocessingUpload () {
            this.$emit("update:backHandler", () => {
                this.$router.go(-1);
            });
            this.$emit("enableButton");
            this.$emit("update:actionHandler", () => {});
            this.showPreprocessingUpload = false;

            // turn on body scroll
            const el = document.body;
            el.classList.remove("over-hidden");
        },
        async getFormData() {
            let formData = new FormData();
            for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i];
                formData.append('files', file);
            }
            return formData;
        },
        setVoucherType (type) {
            this.voucherType = type;
        },
        reset () {
            this.errorMessage = "";
            this.voucher = {};
            this.voucherId = "";
            this.voucherType = "";
            this.activeVoucher = "";
            this.files = [];
            this.ocrData = {};
        },
        getBreadCrumb () {
            let groupType = this.$route.query.groupType;
            if (groupType == Constants.GroupVoucherType.invoice_bill) {
                return this.$t('voucher.sp_bread.invoice_bill');
            }
            if (groupType == Constants.GroupVoucherType.contract) {
                return this.$t('voucher.sp_bread.contract');
            }
            if (groupType == Constants.GroupVoucherType.local_expense_voucher) {
                return this.$t('voucher.sp_bread.local_expense_voucher');
            }
            if (groupType == Constants.GroupVoucherType.other) {
                return this.$t('voucher.sp_bread.other');
            }
        },
        downloadExcel () {
            this.msgErrorDownloadExcel = "";
            let tourNumber = this.editTourInfo['tour_number'];
            const developerName = StorageService.getDeveloperName();
            this.editTourInfo.developerName = developerName;
            // formatDateDefaultの変換時にv-modelに紐づけた日付が壊れるのでディープコピーする
            const param = _.cloneDeep(this.editTourInfo);
            param.departure_date = DateUtils.formatDateDefault(param.departure_date);
            param.return_date = DateUtils.formatDateDefault(param.return_date);
            CashService.downloadExcel(this.cashId, param)
                .then(async response =>{
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if(response.status != 200 ) {
                        this.msgErrorDownloadExcel = this.$t('error.error_unknown');
                        let errorCode = false;
                        let resdata = await fileReader(response.data);
                        response.data = JSON.parse(resdata);
                        errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.msgErrorDownloadExcel = this.$t('error.error_code_' + errorCode);
                        }
                        this.$bvModal.show('errorDownloadExcel');
                    } else {
                        const link = document.createElement('a');
                        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                        link.href = URL.createObjectURL(blob);
                        link.download = "携行現金収支明細-" + tourNumber + ".xlsx";
                        link.target = "_blank";
                        link.click();
                        setTimeout(() => {
                            URL.revokeObjectURL(link.href);
                        }, 200)
                    }
                })
                .catch(error => {
                    this.msgErrorDownloadExcel = this.$root.$t("error.error_unknown");
                    this.$bvModal.show('errorDownloadExcel');
                });
        },
        exportExcel () {
            this.isExportExcelSuccess = false;
            let keyName = StorageService.getCashKeyName();
            this.editTourInfo.keyName = keyName;
            const developerName = StorageService.getDeveloperName();
            this.editTourInfo.developerName = developerName;
            // formatDateDefaultの変換時にv-modelに紐づけた日付が壊れるのでディープコピーする
            const param = _.cloneDeep(this.editTourInfo);
            param.departure_date = DateUtils.formatDateDefault(param.departure_date);
            param.return_date = DateUtils.formatDateDefault(param.return_date);
            CashService.exportExcel(this.cashId, param)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        this.msgExportExcel = this.$t("error.error_unknown");
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.msgExportExcel = this.$t('error.error_code_' + errorCode);
                        }
                        this.$bvModal.show('successRegister');
                    } else {
                        let errorCode = Utils.getErrorCode(response);
                        if (errorCode) {
                            this.isExportExcelSuccess = false;
                            this.msgExportExcel = this.$t('error.error_code_' + errorCode);
                        } else {
                            this.isExportExcelSuccess = true;
                            this.msgExportExcel = this.$t('voucher.message.registerSuccess');
                            StorageService.removeCashName();
                            StorageService.removeCashKeyName();
                        }

                        this.$bvModal.show('successRegister');
                    }
                })
                .catch(error => {
                    this.msgExportExcel = this.$root.$t("error.error_unknown");
                });
        },
        exportExcelSuccess () {
            if (this.isExportExcelSuccess) {
                let tourInfo = JSON.parse(StorageService.getTour());
                this.$router.push(
                    "/tour/after-input?search=" + tourInfo.tour_number
                );
            }
        },
        showPdf (item) {
            this.voucher = item;
            this.showPdfViewer = true;
        },
        closePdf () {
            this.showPdfViewer = false;
        },
        onStorageUpdate (event) {
            if (event.key === "cash_id") {
                this.cash_id = event.newValue;
                this.setErrorMessage(
                    this.$root.$t("error.error_old_data")
                );
            }
            if (event.key === "tour_id") {
                this.tour_id = event.newValue;
                this.setErrorMessage(
                    this.$root.$t("error.error_old_data")
                );
            }
        },
        onClickOfficialRegisterBtn () {
            if (this.cashDetails.has_voucher == true) {
                this.$refs.editTour.init();
                Utils.isCooperator() ? $("#confirmRegister").modal("show") : $("#editTourInfo").modal("show");
            } else {
                this.isConfirmNoPaymentRegisterModalActive = true;
                this.isCancelConfirm = false;
            }
        },
        onClickNoPaymentRegister () {
            this.isConfirmNoPaymentRegisterModalActive = false;
            if (this.isCancelConfirm) {
                $("#confirmRegister").modal("hide");
                $("#editTourInfo").modal("hide");
            } else if (Utils.isCooperator()) {
                $("#confirmRegister").modal("show");            
            } else {
                this.$refs.editTour.init();
                $("#editTourInfo").modal("show");
            }
        },
        nextOfficialRegistration (editTourInfo) {
            this.$refs.confirmRegister.showTour = false;
            this.editTourInfo = editTourInfo;
            $("#editTourInfo").modal("hide");
            this.$nextTick(() => (this.$refs.confirmRegister.showTour = true));
            $("#confirmRegister").modal("show");
        },
        backEditTourInfo () {
            this.$refs.confirmRegister.showTour = false;
            $("#editTourInfo").modal("show");
        },
        onClickCancel () {
            this.$refs.confirmRegister.showTour = false;
            $("#confirmRegister").modal("hide");
            if(!Utils.isCooperator() && !Utils.isReadOnly()) {
                this.isCancelConfirm = true;
                this.isConfirmNoPaymentRegisterModalActive = true;
            }
        },
        showConfirmRegsiter () {
            this.$nextTick(() => (this.$refs.confirmRegister.showTour = true));
            $("#confirmRegister").modal("show");
        }
    },
    mounted () {
        if (localStorage.cash_id) {
            this.cash_id = localStorage.cash_id;
        }
        if (localStorage.tour_id) {
            this.tour_id = localStorage.tour_id;
        }
        setTimeout(() => {
            window.addEventListener("storage", this.onStorageUpdate);
        }, 1000);
    },
    beforeDestroy () {
        window.removeEventListener("storage", this.onStorageUpdate);
    },
    watch: {
        cash_id (newCashId) {
            localStorage.cash_id = newCashId;
        },
        tour_id (newTourId) {
            localStorage.tour_id = newTourId;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/List.vue